var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.142V6.278C13.595 6.625 14 7.263 14 8V10C14 11.103 13.103 12 12 12H8C6.897 12 6 11.103 6 10V8C6 6.897 6.897 6 8 6H9V4H8C5.794 4 4 5.794 4 8V10C4 12.206 5.794 14 8 14H12C14.206 14 16 12.206 16 10V8C16 6.141 14.721 4.589 13 4.142Z",
    fill: "#448EF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0H4C1.794 0 0 1.794 0 4V6C0 7.859 1.279 9.411 3 9.858V7.722C2.405 7.375 2 6.737 2 6V4C2 2.897 2.897 2 4 2H8C9.103 2 10 2.897 10 4V6C10 7.103 9.103 8 8 8H7V10H8C10.206 10 12 8.206 12 6V4C12 1.794 10.206 0 8 0Z",
    fill: "#448EF7"
  })));
};
export default __webpack_public_path__ + "static/media/ic_link.e338cec9.svg";
export { SvgComponent as ReactComponent };